<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Archive</h1>
    </div>

    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Marketing</b> /
      <router-link :to="{ name: 'webinar-page' }">Webinar</router-link> /
      <b>Edit</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12 card mb-4">
        <div class="card-body">
          <form @submit.prevent="submitForm">
            <div class="col-12 mb-4">
              <label><b>Title</b></label>
              <input class="form-control" type="text" v-model="data.title" />
            </div>

            <div class="col-12 mb-4">
              <label><b>Date</b></label>
              <input class="form-control" type="date" v-model="data.date" />
            </div>

            <div class="col-12 mb-4">
              <label><b>Link</b></label>
              <input class="form-control" type="text" v-model="data.link" />
            </div>
            
            <div class="col-12 mb-4">
              <label><b>Visible to</b></label>
              <br/>
              <span v-show="!isCardLoading" v-for="(input, index) in checkBoxInputs" :key="index">
                <input class="mr-2" type="checkbox" :id="`check_${input.id}`" v-model="data.visible_to" :value="input.id">
                <label class="mr-4" :for="`check_${input.id}`">{{ input. name }}</label>
              </span>
            </div>

            <div class="text-center">
              <button
                type="submit"
                class="btn btn-primary btn-wide mt-4 btn-rounded"
              >
                Submit 
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { viewArchive, getCards, updateArchive } from "../../../services/WebinarService";

export default {

  components: { ckeditor: CKEditor.component },

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},

      isCardLoading: true,

      checkBoxInputs: [
        {id: 4, name: 'Black'},
        {id: 3, name: 'Platinum'},
        {id: 2, name: 'Gold'},
        {id: 1, name: 'Silver'},
      ],

      data: {
        title: '',
        date: '',
        link: '',
        visible_to: [],
      },

      webinar_id: null,
    }
  },

  methods: {
    async fetchCards() {
      try {
        const response = await getCards();

        if(response.data.success) {
          this.checkBoxInputs = response.data.data;
        }

      } catch (err) {
        console.error(err);
      }
    },
    async loadData() {
      try {
        const response = await viewArchive(this.$route.params.id);

        if(response.data.success) {
          this.data = response.data.data;
          this.data.date = response.data.data.original_date;
          this.data.visible_to = this.data.visible_to.map(item => item.id);
          this.webinar_id = response.data.data.id;
        }

      } catch (err) {
        console.error(err);
      }
    },

    async submitForm() {
      if(this.webinar_id == null) {
        swal({
          title: 'Failed',
          icon: 'error',
          text: 'Error encountered. Please try again later.'
        });
        return;
      }
      
      try {
        const response = await updateArchive(this.data, this.webinar_id);

        swal({
          title: response.data.success ? 'Success' : 'Failed',
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if(response.data.success) {
          this.$router.push({ name: 'webinar-page' })
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  async mounted() {
    await this.fetchCards();
    this.isCardLoading = false;
    await this.loadData();

  },
}

</script>
